import * as React from "react";
import "../../style/fonts.css";
import "./counterDetailElement.css";

export interface Props {
  icon1x: any;
  icon2x: any;
  icon3x: any;
  num: any;
  title: any;
}

class CounterDetailElement extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <div className="COUNTER_DETAIL_ELEMENT_CONT">
        <img
          src={this.props.icon1x}
          srcSet={`${this.props.icon1x} 1x, ${this.props.icon2x} 2x, ${this.props.icon3x} 3x`}
        />
        <div className="COUNTER_DETAIL_NUM">{this.props.num}</div>
        <div className="COUNTER_DETAIL_ELEMENT_TITLE">
          <div className="SMALL_TEXT2">{this.props.title}</div>
        </div>
      </div>
    );
  }
}

export default CounterDetailElement;



// WEBPACK FOOTER //
// ./src/components/counterDetail/counterDetailElement.tsx